import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

const swiper = new Swiper('.swiper', {
    // If we need pagination
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
        bulletActiveClass: 'ds-slider__dot--active',
        bulletClass: 'ds-slider__dot',
    },

    // Navigation arrows
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },

    modules: [Navigation, Pagination],

    slidesPerView: 2.4,
    spaceBetween: 16,
    slidesOffsetBefore: 16,
    slidesOffsetAfter: 16,
    allowTouchMove: true,
    loop: false,
    preventClicks: true, // default
    preventClicksPropagation: true, // default
    breakpoints: {
        768: {
            slidesPerGroup: 3,
            slidesPerView: 3,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
            spaceBetween: 16,
            allowTouchMove: true,
            preventClicks: true, // default
            preventClicksPropagation: true, // default
        },
        1196: {
            slidesPerGroup: 4,
            slidesPerView: 4,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
            spaceBetween: 24,
            allowTouchMove: false,
            preventClicks: false,
            preventClicksPropagation: false,
        },
    },
});
